import * as devConfig from "./dev.config.js";
import * as localConfig from "./local.config.js";
import * as prodConfig from "./prod.config.js";

let config;

const env = process.env.NODE_ENV;

switch (env) {
  case "production": {
    config = prodConfig;
    break;
  }

  case "development": {
    config = devConfig;
    break;
  }

  case "local": {
    config = localConfig;
    break;
  }

  default: {
    break;
  }
}

export const getDomainAndPort = config.getDomainAndPort;

export const CFG_GENERIC = config.CFG_GENERIC;

export const CFG_ENDPOINTS = config.CFG_ENDPOINTS;
